
import { Options, Vue } from 'vue-class-component'
import Kontakt from '@/components/Frontend/Kontakt/index.vue'

@Options({
  components: {
    Kontakt
  }
})
export default class KontaktView extends Vue {}
